module.exports = false;




//////////////////
// WEBPACK FOOTER
// ./~/detect-node/browser.js
// module id = 1646
// module chunks = 0